import React, { useState, useEffect } from "react";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import {
  Card,
  CardBody,
  Row,
  Table,
  Button,
  Form,
  Col,
  CardHeader,
  Modal,
} from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select, { SingleValue } from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { OptionType } from "../../../../dummyData/dummyData";
import ButtonComponent from "../../../../components/ButtonComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash, faEdit, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import {
  ExtraItem,
  MenuItemSection,
  UpdateCustomizeMenuItem,
} from "../../../../redux/customizeMenuSlice";
import {
  useUpdateCustomMenuImageMutation,
  useUpdateCustomMenuItemMutation,
  useUploadCustomizeMenuLogoFileExtntionHttpsMutation,
} from "../../../../redux/services/customizeMenuService";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import EditPhotoUpload from "../../../../components/EditPhotoUpload";
import { uploadImage } from "../../../../components/imageUploadCompont";
import {
  CustomTypeResponse,
  useLazyGetMenuTypesQuery,
} from "../../../../redux/services/CustomTypeService";
import { useLazyGetMenuItemListQuery } from "../../../../redux/services/setMenuService";
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterEdit,
  customFilterOption,
} from "../../../../utility/Utility";
import { DEFAULT_IMAGE_URL } from "../../../../constants/constans";
import {
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetRestaurantFilterTagsQuery,
} from "../../../../redux/services/menuItemService";
import ControlledSelect from "../../../../components/ControlledSelect";
import { Label } from "reactstrap";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import { useSelector } from "react-redux";

function UpdateCustomizeMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  const { menu } = location.state || {};

  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  const restaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails
  );

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<any>({});
  const {
    control: sectionControl,
    handleSubmit: handleSectionSubmit,
    reset: resetSection,
    watch: watchSection,
  } = useForm<any>({});
  const [sections, setSections] = useState<MenuItemSection[]>(
    menu?.sections || []
  );
  // Row edit state for sections table
  const [editingSectionIndex, setEditingSectionIndex] = useState<number | null>(null);
  const [editingSectionData, setEditingSectionData] = useState<MenuItemSection | null>(null);
  const [draggedSectionIndex, setDraggedSectionIndex] = useState<number | null>(null);
  const [extraItems, setExtraItems] = useState<ExtraItem[]>(
    menu?.extraItems || []
  );

  // State Variables
  const [selectedMenuItemOption, setSelectedMenuItemOption] =
    useState<SingleValue<any>>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [selectedSectionType, setSelectedSectionType] =
    useState<SingleValue<OptionType>>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedExtraItemType, setSelectedExtraItemType] =
    useState<SingleValue<OptionType>>(null);
  const [showImageUpdateModal, setShowImageUpdateModal] = useState(false);
  const [maxCountErrorMessage, setMaxCountErrorMessage] = useState<
    string | null
  >(null);
  const [duplicateItemError, setDuplicateItemError] = useState<string | null>(
    null
  );
  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtension: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtension: "",
  });
  const [isImageUpdateLoading, setIsImageUpdateLoading] = useState(false);
  const [canPortion, setCanPortion] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [portionSize, setPortionSize] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [portionPrice, setPortionPrice] = useState("");
  const [portions, setPortions] = useState<
    { displayName: string; additionalCost: number }[]
  >([]);
  const [editMode, setEditMode] = useState(false);
  // const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
  //   null
  // );

  const [updateCustomMenuItem] = useUpdateCustomMenuItemMutation();

  const [getCustomizeMenuImageReference] =
    useUploadCustomizeMenuLogoFileExtntionHttpsMutation();

  const [updateCustomMenuImage] = useUpdateCustomMenuImageMutation();

  const { data: foodAttributesData } = useGetFoodAttributesListQuery();

  const [triggerGetMenuItemList, { isLoading, data: menuItemsData }] =
    useLazyGetMenuItemListQuery();

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      }
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  const [
    triggerGetMenuTypes,
    { data: menuTypesData },
  ] = useLazyGetMenuTypesQuery();
  // const [isPortionPriceDisable, setIsPortionPriceDisable] =
  //   useState<boolean>(false);
  // const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
  //   useLazyGetPortionSizesQuery();

  const { data: allergenData } = useGetAllergenInformationQuery();

  const menuCategories: any = restaurantData?.categoryTags.map(
    (value: any) => {
      return {
        value: capitalizeFirstLetter(value),
        label: capitalizeFirstLetter(value),
      };
    }
  ) || [{ value: "", label: "" }];

  // useEffect(() => {
  //   if (RestID) {
  //     triggerGetPortionSizes({ restaurantId: RestID });
  //   }
  // }, [RestID, triggerGetPortionSizes]);

  // const portionSizesOptions = portionSizesData.map((size) => ({
  //   value: size.portionSize,
  //   label: size.portionSize,
  // }));

  useEffect(() => {
    if (RestID) {
      triggerGetMenuItemList({ restaurantId: RestID });
      triggerGetMenuTypes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetMenuItemList, triggerGetMenuTypes]);

  const allergenOptions =
    allergenData?.allergenInformation.map((allergen) => ({
      value: allergen.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(allergen.displayName)}
            alt={allergen.displayName}
            width="20px"
            height="20px"
          />
          {allergen.displayName}
        </div>
      ),
    })) || [];

  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,

      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt="attributePhoto"
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  const menuItemsOptions =
    menuItemsData
      ?.filter((item: any) => item.isCustomMenuItem)
      .map((item: any) => ({
        value: item.itemId,
        displayName: item.displayName,
        label: (
          <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
            <img
              src={item.imageUrl || DEFAULT_IMAGE_URL}
              alt="itemPhoto"
              width="50px"
              height="50px"
            />
            {item.displayName}
          </div>
        ),
        price: item.price,
      })) || [];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const menuTypes: CustomTypeResponse[] = menuTypesData || [];
  const getFilteredMenuTypes = () => {
    const sectionTypes = sections.map((section) => section.customItemType);
    return menuTypes.filter((type) => !sectionTypes.includes(type.name));
  };

  // const getFilteredExtraItemTypes = () => {
  //   const extraItemTypes = extraItems.map((item) => item.customItemType);
  //   return menuTypes.filter(
  //     (type) => !extraItemTypes.includes(type.name)
  //   );
  // };

  useEffect(() => {
    if (menuTypes.length > 0) {
      setSelectedSectionType(null);
      setSelectedExtraItemType(null);
    }
  }, [menuTypes]);

  // Watch fields in section and extra item forms
  const sectionName = watchSection("sectionName");
  const sectionCount = watchSection("count");
  // const extraItemName = watchSection("displayName");
  // const extraItemPrice = watchSection("price");
  // const productId = watchSection("productId");

  const isSectionAddButtonDisabled =
    !sectionName || !sectionCount || !selectedSectionType;
  // const isExtraItemAddButtonDisabled =
  //   !extraItemName || !extraItemPrice || !selectedExtraItemType;
  // const isPortionButtonDisabled = !portionSize || !portionPrice;

  useEffect(() => {
    if (menu) {
      setValue("displayName", menu.displayName);
      setValue("abbreviation", menu.abbreviation);
      setValue("totalItems", menu.totalItems);
      const selectedCategory = menuCategories.find(
        (cat: any) => cat.value === menu.category
      );
      setValue("category", selectedCategory || null);
      setValue("imageUrl", menu.imageUrl);
      setValue("tinyId", menu.tinyId || 0);
      setValue("price", menu.price);
      setValue("supportsPreOrdering", menu.supportsPreOrdering || false);
      setValue("productId", menu.productId || "");
      setSections(menu.sections || []);
      setExtraItems(menu.extraItems || []);
      setValue(
        "allergenInformation",
        (menu.allergenInformation || []).map((allergen: string) => ({
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(allergen)}
                alt={allergen}
                width="20px"
                height="20px"
              />
              {allergen}
            </div>
          ),
          value: capitalizeFirstLetterEdit(allergen),
        }))
      );
      setValue(
        "foodAttributes",
        (menu.foodAttributes || []).map((attribute: string) => ({
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(attribute)}
                alt={attribute}
                width="20px"
                height="20px"
              />
              {attribute}
            </div>
          ),
          value: capitalizeFirstLetterEdit(attribute),
        }))
      );
      setValue(
        "filterTags",
        menu.tags
          ? Object.entries(menu.tags as Record<string, string[]>).flatMap(
            ([category, tags]) =>
              tags.map((tag: string) => ({
                value: capitalizeFirstLetterEdit(tag),
                label: (
                  <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
                    {capitalizeFirstLetterEdit(tag)}
                  </div>
                ),
              }))
          )
          : []
      );
      setCanPortion(menu.supportPortionSizes || false);
      setPortions(menu.portions || []);
      if (menu.portions) {
        setPortions(menu.portions);
        if (menu.portions.length > 0) {
          setPortionSize(menu.portions[0]?.displayName || "");
          setPortionPrice(menu.portions[0]?.price?.toString() || "");
        }
      } else {
        setPortions([]);
        setPortionSize("");
        setPortionPrice("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, setValue]);

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  const onSubmit = async (data: any) => {
    if (sections.length === 0) {
      setErrorMessage("Cannot update with empty sections");
      return;
    }
    const structuredTags: { [key: string]: string[] } = {};

    // Loop through selected tags and group by category
    if (filterTagsData?.filterTags && data.filterTags) {
      Object.entries(filterTagsData.filterTags).forEach(
        ([categoryKey, categoryData]) => {
          const selectedTags = (data.filterTags ?? [])
            .map((tag: any) => tag.value)
            .filter((tagValue: string) =>
              (categoryData.tags as any[]).some(
                (tagObj) => tagObj.tag === tagValue
              )
            );

          if (selectedTags.length > 0) {
            structuredTags[categoryKey.toLowerCase()] = selectedTags.map(
              (tag: string) => tag.toLowerCase()
            );
          }
        }
      );
    }
    setIsSaving(true);
    const payload: UpdateCustomizeMenuItem = {
      restaurantId: RestID,
      customMenuId: menu.id,
      sections,
      displayName: data.displayName,
      tinyId:+data.tinyId || 0,
      abbreviation: data.abbreviation,
      category: data.category.value,
      totalItems: menu?.totalItems ?? 10,
      price: +data.price,
      extraItems,
      allergenInformation: data?.allergenInformation?.map(
        (item: any) => item.value
      ),
      foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
      supportPortionSizes: canPortion,
      portions: canPortion
        ? portions.map((portion) => ({
          displayName: portion.displayName || "",
          additionalCost: portion.additionalCost || 0,
        }))
        : [],
      productId: data.productId,
      tags: structuredTags,
      supportsPreOrdering: data.supportsPreOrdering,
      // filterTags: data.filterTags.map((item: any) => item.value),
    };

    try {
      const response: any = await updateCustomMenuItem(payload).unwrap();
      if (response?.error?.status === 409 && response?.error?.data === "ProductId Already exists") {
        toast.error("ProductId Already exists");
        setIsSaving(false);
      } else {
        toast.success("Customize menu updated successfully");
        navigate("/productCatalogue/products");
      }
    } catch (error: any) {
      if (error.status === 409) {
        toast.error("Customize menu name already exists");
      }
      toast.error("Failed to update custom menu item");
    } finally {
      setIsSaving(false);
    }
  };

  const addSection = (sectionData: any) => {
    const selectedType = menuTypes.find(
      (type) => type.name === selectedSectionType?.label
    );

    if (selectedType && sectionData.count > (selectedType.availableCount ?? 0)) {
      setMaxCountErrorMessage(
        "Your max allowed count is greater than the availableCount"
      );
      return;
    }

    const newSection: MenuItemSection = {
      displayName: sectionData.sectionName,
      maxAllowedCount: parseInt(sectionData.count),
      isRequired: sectionData.isRequired,
      customItemType: selectedSectionType?.label || "",
      customMenuItemTypeId: selectedType?.id || "",
    };
    setSections([...sections, newSection]);
    resetSectionForm();
    setMaxCountErrorMessage(null);
  };

  const resetSectionForm = () => {
    resetSection({
      sectionName: "",
      count: "",
      isRequired: false,
    });
    setSelectedSectionType(null);
    setErrorMessage(null);
  };

  const deleteSection = (index: number) => {
    const newSections = [...sections];
    newSections.splice(index, 1);
    setSections(newSections);
  };

  const startEditSection = (index: number) => {
    if (!editMode) return;
    setEditingSectionIndex(index);
    setEditingSectionData({ ...sections[index] });
    setErrorMessage(null);
  };

  const cancelEditSection = () => {
    setEditingSectionIndex(null);
    setEditingSectionData(null);
    setErrorMessage(null);
  };

  const saveEditSection = (index: number) => {
    if (!editingSectionData) return;
    // basic validation
    if (!editingSectionData.displayName || !editingSectionData.maxAllowedCount) {
      setErrorMessage("Please provide section name and max count");
      return;
    }

    const updated = [...sections];
    updated[index] = { ...editingSectionData };
    setSections(updated);
    setEditingSectionIndex(null);
    setEditingSectionData(null);
  };

  const handleSectionDragStart = (index: number) => {
    if (!editMode || editingSectionIndex !== null) return;
    setDraggedSectionIndex(index);
  };

  const handleSectionDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleSectionDrop = (e: React.DragEvent, dropIndex: number) => {
    e.preventDefault();

    if (
      !editMode ||
      editingSectionIndex !== null ||
      draggedSectionIndex === null ||
      draggedSectionIndex === dropIndex
    ) {
      setDraggedSectionIndex(null);
      return;
    }

    const updatedSections = [...sections];
    const [draggedSection] = updatedSections.splice(draggedSectionIndex, 1);
    updatedSections.splice(dropIndex, 0, draggedSection);

    setSections(updatedSections);
    setDraggedSectionIndex(null);
  };

  const handleSectionDragEnd = () => {
    setDraggedSectionIndex(null);
  };

  // const addExtraItem = (itemData: any) => {
  //   const selectedType = menuTypes.find(
  //     (type) => type.name === selectedExtraItemType?.value
  //   );

  //   const newItem: ExtraItem = {
  //     displayName: itemData.displayName,
  //     price: +itemData.price,
  //     type: selectedMenuItemOption?.value === "item" ? "item" : "group",
  //     customItemType: selectedExtraItemType?.value,
  //     menuItemId: itemData.menuItemId,
  //     customMenuItemTypeId: selectedType?.id || "",
  //   };
  //   setExtraItems([...extraItems, newItem]);
  //   resetExtraItemForm();
  // };

  // const resetExtraItemForm = () => {
  //   resetSection({
  //     displayName: "",
  //     price: "",
  //     customItemType: "",
  //   });
  //   setSelectedExtraItemType(null);
  //   setErrorMessage(null);
  // };

  const deleteExtraItem = (index: number) => {
    const newExtraItems = [...extraItems];
    newExtraItems.splice(index, 1);
    setExtraItems(newExtraItems);
  };

  const addMenuItem = () => {
    if (selectedMenuItemOption) {
      const isDuplicate = extraItems.some(
        (item) => item.menuItemId === selectedMenuItemOption.value
      );

      if (isDuplicate) {
        setDuplicateItemError("The item already exists.");
        return;
      }

      const newItem: ExtraItem = {
        menuItemId: selectedMenuItemOption.value,
        displayName: selectedMenuItemOption.displayName,
        price: selectedMenuItemOption.price,
        type: "item",
        customMenuItemTypeId: "", // Single menu items don't have custom menu type ID
      };
      setExtraItems([...extraItems, newItem]);
      setSelectedMenuItemOption(null);
      setDuplicateItemError(null);
    }
  };

  const handleUpdatePhoto = () => {
    setShowImageUpdateModal(true);
  };

  const handleCloseModal = () => {
    setShowImageUpdateModal(false);
  };

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtension: e.fileExtension,
    });
  };

  const handleCustomizeMenuImageUpdate = async () => {
    setIsImageUpdateLoading(true);

    const imageRef = await uploadImage(getCustomizeMenuImageReference, {
      fileExtention: uploadedImgDetails.fileExtension,
      formData: uploadedImgDetails.formData,
    });
    const updateImageResponse = await updateCustomMenuImage({
      imgRef: imageRef,
      restaurantId: RestID,
      customMenuId: menu.id,
    });
    if ("data" in updateImageResponse) {
      toast.success("Customize Menu Image Successfully Updated");
      navigate("/productCatalogue/products");
    } else {
      toast.error("Something Went Wrong");
    }
    setIsImageUpdateLoading(false);
  };

  // const handleCheckboxChangeForPortion = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   setCanPortion(event.target.checked);
  // };

  // const addPortion = () => {
  //   if (!portionSize) {
  //     setPortionErrorMessage("Please select a portion size.");
  //     return;
  //   }

  //   const portionExists = portions.some(
  //     (portion) => portion.displayName === portionSize
  //   );

  //   if (portionExists) {
  //     setPortionErrorMessage("Portion size is already added.");
  //   } else {
  //     const selectedPortion = portionSizesData.find(
  //       (size) => size.portionSize === portionSize
  //     );

  //     const portionSizeCost =
  //       selectedPortion &&
  //         selectedPortion.portionSize === portionSizesData[0]?.portionSize
  //         ? 0
  //         : Number(portionPrice);

  //     setPortions([
  //       ...portions,
  //       { displayName: portionSize, additionalCost: portionSizeCost },
  //     ]);

  //     setPortionSize("");
  //     setPortionPrice("");
  //     setValue("portionSize", "");
  //     setValue("portionPrice", 0);
  //     setPortionErrorMessage(null);
  //   }
  // };

  // const deletePortion = (index: number) => {
  //   const updatedPortions = portions.filter((_, i) => i !== index);
  //   setPortions(updatedPortions);
  //   setPortionErrorMessage(null);
  // };

  // const handleSelectPortion = (option: any) => {
  //   setPortionSize(option.value);

  //   if (option.value === portionSizesData[0].portionSize) {
  //     setValue("portionPrice", 0);
  //     setIsPortionPriceDisable(true);
  //   } else {
  //     setIsPortionPriceDisable(false);
  //   }
  // };

  return (
    <div>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader className="bg-white d-flex justify-content-between">
          <h4>Update Customized Menu</h4>
          <div>
            {!editMode && (
              <Button
                variant="light"
                type="button"
                onClick={handleEditButtonClick}
              >
                <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <Col lg="4">
                <label>Menu Photo</label>
              </Col>
              <Col lg="8">
                <img
                  src={menu.imageUrl}
                  alt="menuImage"
                  style={{
                    width: "30%",
                    height: "auto",
                    borderRadius: "30px",
                  }}
                />
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleUpdatePhoto}
                  style={{ position: "relative", top: "45%", right: "10%" }}
                  title="Edit Photo"
                  disabled={!editMode}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
              </Col>
            </Row>

            <Modal
              show={showImageUpdateModal}
              onHide={handleCloseModal}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Update Photo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditPhotoUpload
                  imageUrl={uploadedImgDetails.imgSrc}
                  onUpload={imageUploadCallback}
                />
              </Modal.Body>
              <Modal.Footer>
                {isImageUpdateLoading ? (
                  <ButtonComponent
                    titel="Saving..."
                    type="button"
                    icon={<FontAwesomeIcon icon={faSpinner} spin />}
                    isDisabled={isImageUpdateLoading}
                    onClick={handleCustomizeMenuImageUpdate}
                  />
                ) : (
                  <ButtonComponent
                    titel="Save"
                    type="button"
                    isDisabled={isImageUpdateLoading}
                    onClick={handleCustomizeMenuImageUpdate}
                  />
                )}
              </Modal.Footer>
            </Modal>

            <hr />

            <ControlledRowTextField
              label={"Customize Menu Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter Customize Menu Name"}
              isRequired={true}
              control={control}
              rules={{ required: "Customize Menu Name is required" }}
              isDisabled={!editMode}
            />
            {errors.displayName && (
              <span className="text-danger">
                {errors.displayName.message as string}
              </span>
            )}
            <hr />
            <ControlledRowTextField
              label={"Abbreviation"}
              inputName={"abbreviation"}
              inputType={"text"}
              placeholder={"Enter Abbreviation"}
              control={control}

              isDisabled={!editMode}
            />

            <hr />
            <ControlledSelect
              label={"Category"}
              inputName={"category"}
              control={control}
              isMulti={false}
              optionsList={menuCategories}
              rules={{ required: "Category is required" }}
              isDisabled={!editMode}
            />
            {errors.category && (
              <p className="text-danger">{errors.category.message as string}</p>
            )}
            {/*
            <hr />
            <ControlledRowTextField
              label={"Total Items"}
              inputName={"totalItems"}
              inputType={"number"}
              placeholder={"Enter Total Items"}
              isRequired={true}
              control={control}
              rules={{ required: "Total Items is required" }}
              isDisabled={!editMode}
            />
            {errors.totalItems && (
              <span className="text-danger">
                {errors.totalItems.message as string}
              </span>
            )}
            */}
            <hr />
            <ControlledRowTextField
              label={"Price (Rs.)"}
              inputName={"price"}
              inputType={"number"}
              placeholder={"Enter Price"}
              isRequired={true}
              control={control}
              rules={{
                required: "Item Price is required",
                min: {
                  value: 0.01,
                  message: "Item Price must be greater than 0",
                },
              }}
              isDisabled={!editMode}
            />
            {errors.price && (
              <span className="text-danger">
                {errors.price.message as string}
              </span>
            )}
            <hr />

            <ControlledRowTextField
              label={"Product ID Name"}
              inputName={"productId"}
              inputType={"text"}
              placeholder={"Enter Product ID Name"}
              isRequired={true}
              control={control}
              isDisabled={!editMode}
            />
            <hr/>
            <ControlledRowTextField
              label={"Tiny ID"}
              inputName={"tinyId"}
              inputType={"number"}
              placeholder={"Enter Tiny ID"}
              isRequired={false}
              control={control}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledSelect
              label={"Allergen Information"}
              inputName={"allergenInformation"}
              control={control}
              isMulti={true}
              optionsList={allergenOptions}
              isRequired={false}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledSelect
              label={"Food Attributes"}
              inputName={"foodAttributes"}
              control={control}
              isMulti={true}
              optionsList={foodAttributesOptions}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledSelect
              label={"Filter Tags"}
              inputName={"filterTags"}
              control={control}
              isMulti={true}
              optionsList={filterTagsOptions}
              isDisabled={!editMode}
            />
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="supportsPreOrdering"
                >
                  Supports Pre-Ordering
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="supportsPreOrdering"
                  checked={watch("supportsPreOrdering")}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setValue("supportsPreOrdering", event.target.checked);
                  }}
                  disabled={!editMode}
                />
              </Col>
            </Row>
            <hr />
            {/*
            <Row className="mb-3">
              <Col lg={4}>
                <Label>Portion Available</Label>
              </Col>
              <Col lg={8}>
                <input
                  type="checkbox"
                  checked={canPortion}
                  className="form-check-input"
                  onChange={handleCheckboxChangeForPortion}
                  disabled={!editMode}
                />
                {canPortion && (
                  <>
                    <hr />
                    <div className="portion-section">
                      <div className="portion-inputs">
                        <Row>
                          <Col md={5} className="mt-1">
                            <ControlledRowSelectPortion
                              inputName="portionSize"
                              control={control}
                              optionsList={portionSizesOptions}
                              placeholder="Select portion size"
                              // onChange={(option: any) =>
                              //   setPortionSize(option ? option.value : "")
                              // }
                              onChange={(option: any) =>
                                handleSelectPortion(option)
                              }
                              isDisabled={!editMode}
                            />
                            <br />
                          </Col>

                          <Col md={5}>
                            <ControlledRowTextFieldForPortion
                              inputName={"portionPrice"}
                              inputType={"number"}
                              placeholder={"Enter portion price"}
                              control={control}
                              onChange={(e) => {
                                const value = Number(e.target.value);
                                if (value >= 0) {
                                  setPortionPrice(e.target.value);
                                } else {
                                  setPortionPrice("");
                                  setPortionErrorMessage(
                                    "Portion price cannot be negative."
                                  );
                                }
                              }}
                              // isDisabled={!editMode }
                              isDisabled={isPortionPriceDisable || !editMode}
                            />
                          </Col>

                          <Col md={2}>
                            <ButtonComponent
                              type="button"
                              titel="+Add"
                              // isDisabled={isPortionButtonDisabled || !editMode}
                              isDisabled={
                                (portionSizesData?.[0]?.portionSize ===
                                  portionSize
                                  ? false
                                  : isPortionButtonDisabled) || !editMode
                              }
                              onClick={addPortion}
                            />
                          </Col>
                        </Row>
                      </div>
                      {portionErrorMessage && (
                        <p className="text-danger">{portionErrorMessage}</p>
                      )}
                      <Table>
                        <thead>
                          <tr>
                            <th>Size</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portions.map((portion, index) => (
                            <tr key={index}>
                              <td>{portion.displayName}</td>
                              <td>{portion.additionalCost}</td>
                              <td>
                                <Button
                                  variant="light"
                                  onClick={() => deletePortion(index)}
                                  disabled={!editMode}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    title="Delete"
                                    color="#F24E1E"
                                  />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </>
                )}
              </Col>
            </Row>
            */}
          </form>
        </CardBody>
      </Card>

      <Card className="mt-3">
        <CardBody className="mt-3">
          <h4>Sections</h4>
          <Form>
            <Row>
              <Col md={3}>
                <Controller
                  name="sectionName"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Section Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter section name"
                        {...field}
                        disabled={!editMode}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={2}>
                <Controller
                  name="count"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Max Count</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter count"
                        {...field}
                        disabled={!editMode}
                      />
                      {maxCountErrorMessage && (
                        <span className="text-danger">
                          {maxCountErrorMessage}
                        </span>
                      )}
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Custom Menu Type</Form.Label>
                  <Select
                    value={selectedSectionType}
                    onChange={(option) =>
                      setSelectedSectionType(option as SingleValue<OptionType>)
                    }
                    options={getFilteredMenuTypes().map((type) => ({
                      label: type.name,
                      value: type.name,
                    }))}
                    placeholder="Search menu item"
                    isSearchable
                    isDisabled={!editMode}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Controller
                  name="isRequired"
                  control={sectionControl}
                  defaultValue={false}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Required</Form.Label>
                      <Form.Check
                        type="checkbox"
                        checked={field.value}
                        {...field}
                        disabled={!editMode}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+ Add"
                  isDisabled={isSectionAddButtonDisabled || !editMode}
                  onClick={handleSectionSubmit(addSection)}
                  type="button"
                />
              </Col>
            </Row>
          </Form>
          <hr />
          <div className="selected-items-container">
            <h5>Selected Items</h5>
            <Table bordered className="mt-3" responsive>
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>Order</th>
                  <th>Section Name</th>
                  <th>Count</th>
                  <th>Custom Menu Type</th>
                  <th>Required</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sections.map((section, index) => {
                  const isEditing = editingSectionIndex === index;
                  return (
                    <tr
                      key={`${section.customItemType || "section"}-${index}`}
                      draggable={editMode && editingSectionIndex === null}
                      onDragStart={() => handleSectionDragStart(index)}
                      onDragOver={handleSectionDragOver}
                      onDrop={(e) => handleSectionDrop(e, index)}
                      onDragEnd={handleSectionDragEnd}
                      style={{
                        backgroundColor:
                          draggedSectionIndex === index ? "#e3f2fd" : "white",
                        opacity: draggedSectionIndex === index ? 0.5 : 1,
                        cursor:
                          editMode && editingSectionIndex === null
                            ? "move"
                            : "default",
                      }}
                    >
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          cursor:
                            editMode && editingSectionIndex === null
                              ? "move"
                              : "default",
                        }}
                      >
                        {editMode && editingSectionIndex === null ? (
                          <FontAwesomeIcon
                            icon={faGripVertical}
                            color="#666"
                            size="lg"
                          />
                        ) : (
                          index + 1
                        )}
                      </td>
                      <td>
                        {isEditing ? (
                          <Form.Control
                            type="text"
                            value={editingSectionData?.displayName || ""}
                            onChange={(e) =>
                              setEditingSectionData(
                                (prev) => prev ? { ...prev, displayName: e.target.value } : prev
                              )
                            }
                            disabled={!editMode}
                          />
                        ) : (
                          section.displayName
                        )}
                      </td>
                      <td>
                        {isEditing ? (
                          <Form.Control
                            type="number"
                            value={editingSectionData?.maxAllowedCount?.toString() || ""}
                            onChange={(e) =>
                              setEditingSectionData(
                                (prev) => prev ? { ...prev, maxAllowedCount: parseInt(e.target.value || "0") } : prev
                              )
                            }
                            disabled={!editMode}
                          />
                        ) : (
                          section.maxAllowedCount
                        )}
                      </td>
                      <td>
                        {isEditing ? (
                          <Select
                            value={editingSectionData ? { label: editingSectionData.customItemType, value: editingSectionData.customItemType } : null}
                            onChange={(option: any) =>
                              setEditingSectionData((prev) => prev ? { ...prev, customItemType: option?.value || "" } : prev)
                            }
                            options={getFilteredMenuTypes().map((type) => ({ label: type.name, value: type.name }))}
                            isDisabled={!editMode}
                          />
                        ) : (
                          section.customItemType || "-"
                        )}
                      </td>
                      <td>
                        {isEditing ? (
                          <Form.Check
                            type="checkbox"
                            checked={!!editingSectionData?.isRequired}
                            onChange={(e) =>
                              setEditingSectionData((prev) => prev ? { ...prev, isRequired: e.target.checked } : prev)
                            }
                            disabled={!editMode}
                          />
                        ) : (
                          section.isRequired ? "Yes" : "No"
                        )}
                      </td>
                      <td>
                        {isEditing ? (
                          <div style={{ display: 'flex', gap: 8 }}>
                            <Button size="sm" color="primary" onClick={() => saveEditSection(index)} disabled={!editMode}>
                              Save
                            </Button>
                            <Button size="sm" color="secondary" onClick={cancelEditSection}>
                              Cancel
                            </Button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', gap: 8 }}>
                            <Button variant="light" onClick={() => startEditSection(index)} disabled={!editMode}>
                              <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
                            </Button>
                            <Button variant="light" onClick={() => deleteSection(index)} disabled={!editMode}>
                              <FontAwesomeIcon icon={faTrash} title="Delete" color="#F24E1E" />
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {errorMessage && (
              <div className="text-danger mt-2">{errorMessage}</div>
            )}
          </div>
        </CardBody>
      </Card>

      {/* Extra Items */}
      <Card className="mt-3">
        <CardBody className="mt-3">
          <h4>Extra Items</h4>
          {/* <h5>Add Group Items</h5>
          <Form onSubmit={handleSectionSubmit(addExtraItem)}>
            <Row className="d-flex">
              <Col md={4}>
                <Controller
                  name="displayName"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Item Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter item name"
                        {...field}
                        disabled={!editMode}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Controller
                  name="price"
                  control={sectionControl}
                  defaultValue=""
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Price</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter price"
                        {...field}
                        disabled={!editMode}
                      />
                    </Form.Group>
                  )}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Custom Menu Type</Form.Label>
                  <Select
                    value={selectedExtraItemType}
                    onChange={(option) =>
                      setSelectedExtraItemType(
                        option as SingleValue<OptionType>
                      )
                    }
                    options={getFilteredExtraItemTypes().map((type) => ({
                      label: type.name,
                      value: type.name,
                    }))}
                    placeholder="Search menu item"
                    isSearchable
                    isDisabled={!editMode}
                  />
                </Form.Group>
              </Col>

              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+Add"
                  type="button"
                  isDisabled={isExtraItemAddButtonDisabled || !editMode}
                  onClick={handleSectionSubmit(addExtraItem)}
                />
              </Col>
            </Row>
          </Form> */}
          <br />
          <h5>Add Single Item</h5>
          <Form>
            <Row className="d-flex align-items-center">
              <Col md={10}>
                <Select
                  value={selectedMenuItemOption}
                  onChange={setSelectedMenuItemOption}
                  options={menuItemsOptions}
                  placeholder={isLoading ? "Loading..." : "Search menu item"}
                  isSearchable
                  loadingMessage={() => "Loading menu items..."}
                  noOptionsMessage={() =>
                    isLoading ? "Loading..." : "No items found"
                  }
                  filterOption={customFilterOption}
                  isDisabled={!editMode}
                />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <ButtonComponent
                  titel="+Add"
                  type="button"
                  onClick={addMenuItem}
                  isDisabled={!selectedMenuItemOption || !editMode}
                />
              </Col>
            </Row>
            {duplicateItemError && (
              <div className="text-danger mt-2">{duplicateItemError}</div>
            )}
          </Form>
          <hr />

          <Table bordered responsive>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Price</th>
                <th>Custom Menu Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {extraItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.displayName}</td>
                  <td>{item.price}</td>
                  <td>{item.type === "item" ? "-" : item.customItemType}</td>
                  <td>
                    <Button
                      variant="light"
                      onClick={() => deleteExtraItem(index)}
                      disabled={!editMode}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        title="Delete"
                        color="#F24E1E"
                      />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
        <div className="d-flex justify-content-end my-2 mx-5">
          {isSaving ? (
            <ButtonComponent
              type="submit"
              icon={
                <FontAwesomeIcon icon={faSpinner} spin title="Updating..." />
              }
              titel="Updating..."
              isDisabled={true}
            />
          ) : (
            <ButtonComponent
              titel="Update"
              type="submit"
              onClick={handleSubmit(onSubmit)}
              isDisabled={!editMode}
            />
          )}
        </div>
      </Card>
    </div>
  );
}

export default UpdateCustomizeMenu;
